module.exports = __webpack_public_path__ + "static/media/slmundb1.a385b3ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/slmundb1.jpg
// module id = 306
// module chunks = 0